import axios from "axios";

var BASE_URL;
if (window.location.hostname === "localhost") {
  BASE_URL = "http://13.235.51.53:8000";
} else {
  BASE_URL = "https://st-andrews-backend.onrender.com";
}
// BASE_URL = "http://localhost:8000";


const get = (url) => {
  return axios
    .get(`${BASE_URL}/${url}`)
    .then((res) => res)
    .catch((err) => err.response);
};

const post = (url, payload = {}) => {
  return axios
    .post(`${BASE_URL}/${url}`, payload)
    .then((res) => res)
    .catch((err) => err.response);
};

const deleteMethod = (url, payload = {}) => {
  return axios
    .delete(`${BASE_URL}/${url}`, { data: payload })
    .then((res) => res)
    .catch((err) => err.response);
};

const deleteByParams = (url, payload = {}) => {
  return axios
    .delete(`${BASE_URL}/${url}`, { params: payload })
    .then((res) => res)
    .catch((err) => err.response);
};

const put = (url, payload = {}) => {
  return axios
    .put(`${BASE_URL}/${url}`, payload)
    .then((res) => res)
    .catch((err) => err.response);
};

const postWithFormData = (url, formDataObj) => {
  return axios({
    method:"post",
    url: `${BASE_URL}/${url}`,
    data: formDataObj,
    headers: { "Content-Type": "multipart/form-data" }
  });
}

export { get, post, deleteMethod, deleteByParams, put, postWithFormData };
